import { render, staticRenderFns } from "./BetweenEchart.vue?vue&type=template&id=2b85de73&scoped=true&"
import script from "./BetweenEchart.vue?vue&type=script&lang=js&"
export * from "./BetweenEchart.vue?vue&type=script&lang=js&"
import style0 from "./BetweenEchart.vue?vue&type=style&index=0&id=2b85de73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85de73",
  null
  
)

export default component.exports